import { render } from "./ImageCropper.vue?vue&type=template&id=7ab54267"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__